// app/features/paymentMethod/paymentMethodSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaymentMethod } from "../context";
interface PaymentMethodState {
  paymentMethods: PaymentMethod[];
  loading: boolean;
  error: string | null;
  setupIntentClientSecret: string | null;
}

const initialState: PaymentMethodState = {
  paymentMethods: [],
  loading: false,
  error: null,
  setupIntentClientSecret: null,
};

const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState,
  reducers: {
    fetchPaymentMethodsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPaymentMethodsSuccess(state, action: PayloadAction<PaymentMethod[]>) {
      state.paymentMethods = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchPaymentMethodsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    addPaymentMethod(state, action: PayloadAction<PaymentMethod>) {
      state.paymentMethods.push(action.payload);
    },
    setDefaultPaymentMethod(state, action: PayloadAction<string>) {
      state.paymentMethods = state.paymentMethods.map((method) => ({
        ...method,
        is_default: method.id === action.payload,
      }));
    },
    setSetupIntentClientSecret(state, action: PayloadAction<string>) {
      state.setupIntentClientSecret = action.payload;
    },
    clearSetupIntentClientSecret(state) {
      state.setupIntentClientSecret = null;
    },
    removePaymentMethod(state, action: PayloadAction<string>) {
      state.paymentMethods = state.paymentMethods.filter(
        (method) => method.id !== action.payload
      );
    },
    resetPaymentMethodLoading(state) {
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchPaymentMethodsStart,
  fetchPaymentMethodsSuccess,
  fetchPaymentMethodsFailure,
  addPaymentMethod,
  setDefaultPaymentMethod,
  setSetupIntentClientSecret,
  clearSetupIntentClientSecret,
  resetPaymentMethodLoading,
  removePaymentMethod
} = paymentMethodSlice.actions;

export default paymentMethodSlice.reducer;
